































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import {
  Configuration,
  TitleTemplatePublic,
  RedCapital,
  SelectedCountry
} from "@/configuration";
import API from "@/api";
import DniField from "@/components/DniFieldBusiness.vue";
import { isRutValid } from "@/utils";

@Component({
  metaInfo: {
    title: "Solicitar credito",
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  data() {
    return {
      RedCapital,
      SelectedCountry,
      valid: true,
      dialog: false,
      errorMessage: null,
      name: "",
      rut: "",
      phone: null,
      email: "",
      needSelected: 0,
      salesSelected: 0,
      averageSelected: 0,
      debt: null,
      propertyCost: null,
      propertyWarrantySelected: 0,
      propertyDebt: null,
      need: [
        {
          id: 1,
          // @ts-ignore
          text: `Entre ${RedCapital[SelectedCountry].Currency.Prefix}10${RedCapital[SelectedCountry].Currency.Suffix} y ${RedCapital[SelectedCountry].Currency.Prefix}50${RedCapital[SelectedCountry].Currency.Suffix} millones de pesos`
        },
        {
          id: 2,
          // @ts-ignore
          text: `Entre ${RedCapital[SelectedCountry].Currency.Prefix}50${RedCapital[SelectedCountry].Currency.Suffix} y ${RedCapital[SelectedCountry].Currency.Prefix}100${RedCapital[SelectedCountry].Currency.Suffix} millones de pesos`
        },
        {
          id: 3,
          // @ts-ignore
          text: `Entre ${RedCapital[SelectedCountry].Currency.Prefix}100${RedCapital[SelectedCountry].Currency.Suffix} y ${RedCapital[SelectedCountry].Currency.Prefix}400${RedCapital[SelectedCountry].Currency.Suffix} millones de pesos`
        },
        {
          id: 4,
          // @ts-ignore
          text: `Sobre ${RedCapital[SelectedCountry].Currency.Prefix}400${RedCapital[SelectedCountry].Currency.Suffix} millones de pesos`
        }
      ],
      sales: [
        {
          id: 1,
          text: "Personas"
        },
        {
          id: 2,
          text: "Empresas"
        },
        {
          id: 3,
          text: "Ambos"
        }
      ],
      average: [
        {
          id: 1,
          // @ts-ignore
          text: `Entre ${RedCapital[SelectedCountry].Currency.Prefix}0${RedCapital[SelectedCountry].Currency.Suffix} y ${RedCapital[SelectedCountry].Currency.Prefix}20${RedCapital[SelectedCountry].Currency.Suffix} millones de pesos`
        },
        {
          id: 2,
          // @ts-ignore
          text: `Entre ${RedCapital[SelectedCountry].Currency.Prefix}20${RedCapital[SelectedCountry].Currency.Suffix} y ${RedCapital[SelectedCountry].Currency.Prefix}50${RedCapital[SelectedCountry].Currency.Suffix} millones de pesos`
        },
        {
          id: 3,
          // @ts-ignore
          text: `Entre ${RedCapital[SelectedCountry].Currency.Prefix}50${RedCapital[SelectedCountry].Currency.Suffix} y ${RedCapital[SelectedCountry].Currency.Prefix}200${RedCapital[SelectedCountry].Currency.Suffix} millones de pesos`
        },
        {
          id: 4,
          // @ts-ignore
          text: `Sobre ${RedCapital[SelectedCountry].Currency.Prefix}200${RedCapital[SelectedCountry].Currency.Suffix} millones de pesos`
        }
      ],
      warranty: [
        {
          id: 1,
          text: "Ninguna"
        },
        {
          id: 2,
          text: "Casa"
        },
        {
          id: 3,
          text: "Oficina"
        },
        {
          id: 4,
          text: "Terreno"
        },
        {
          id: 5,
          text: "Industrial"
        },
        {
          id: 6,
          text: "Local comercial"
        },
        {
          id: 7,
          text: "Agrícola"
        }
      ],
      rules: {
        notEmpty: [(v: any) => !!v || "Ingrese un valor"],
        name: [
          (v: any) => !!v || "Ingrese nombre",
          (v: any) =>
            v.length <= 255 || "Nombre no puede exceder los 255 caracteres."
        ],
        email: [
          (v: any) => !!v || "Ingrese correo electrónico",
          (v: any) => /.+@.+/.test(v) || "La dirección debe ser válida"
        ],
        rut: [
          (v: any) =>
          // @ts-ignore
            !!v || `${RedCapital[SelectedCountry].DniName} es requerido`,
          (v: any) =>
            /^(\d{1,3}(?:\.\d{1,3}){2}-[\dkK])$/.test(v) ||
            // @ts-ignore
            `${RedCapital[SelectedCountry].DniName} invalido Ej: 12.345.678-9`
        ],
        phone: [(v: any) => !/[^\d]/gim.test(v) || "Tiene que ser solo numeros"]
      }
    };
  },
  methods: {
    async validate() {
      // @ts-ignore
      if (this.$refs.form.validate()) {
        API.credit({
          name: this.$data.name,
          rut: this.$data.rut,
          phone: this.$data.phone,
          email: this.$data.email,
          needSelected: this.$data.needSelected,
          salesSelected: this.$data.salesSelected,
          averageSelected: this.$data.averageSelected,
          debt: this.$data.debt,
          propertyCost: this.$data.propertyCost,
          propertyDebt: this.$data.propertyDebt,
          propertyWarrantySelected: this.$data.propertyWarrantySelected
        })
          .then(res => {
            this.$data.dialog = true;
            setTimeout(() => {
              this.$router.push({
                path: "/"
              });
            }, Configuration.Redirection.timeout);
          })
          .catch(error => {
            this.$data.errorMessage = "Error";
          });
      }
    }
  },
  components: {
    DniField
  }
})
export default class Contact extends Vue {}
